var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-empty',{attrs:{"description":"无效链接","image":"error"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }